var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentBetSlipState <= 1 || _vm.isActive
    ? _c(
        "div",
        { staticClass: "promotionVoucher" },
        [
          _c("v-checkbox", {
            attrs: {
              "hide-details": "",
              id: _vm.betId,
              disabled: _vm.disabled
            },
            on: { change: _vm.toggleSelected },
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [
                      _c("div", {
                        staticClass: "checkboxLabel",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t(
                              "Betslip.voucher" +
                                (_vm.voucher.DiscountPercentage === null
                                  ? ".SO"
                                  : "") +
                                ".label",
                              {
                                currencySymbol: _vm.currencySymbol,
                                name:
                                  _vm.voucher.Description ||
                                  _vm.voucher.description,
                                amount: _vm.voucher.CurrentAmount,
                                SOinfo: _vm.soInfo,
                                exp: _vm.parseDateTime(_vm.voucher.ExpiryDate)
                              }
                            )
                          )
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3987259391
            ),
            model: {
              value: _vm.isActive,
              callback: function($$v) {
                _vm.isActive = $$v
              },
              expression: "isActive"
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f7d9605", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f7d9605","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/promotionVouchers/voucher.vue
// module id = null
// module chunks = 